import ReglementApi from '@/api/reglement';
import StoreBuilder from '../store-builder';

const builder = new StoreBuilder('reglement');
builder.addStatePart('reglement', null, param => ReglementApi.getReglementTiersDefaut(param));
builder.addStatePart('reglementCommande', null, ({ numTiers, param }) => ReglementApi.getPropositionReglementTiers(numTiers, param));

export default builder.build();
